import { css } from 'emotion';
import { space } from '@joykit';

export namespace styles {
  export const container = css({});
  export const themeRow = css({
    ':not(:last-child)': {
      marginBottom: 16
    }
  });

  export const themeLabel = css({
    fontSize: '14px',
    color: '#484848',
    cursor: 'pointer',
    textAlign: 'left',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    font: 'inherit',
    outline: 'inherit'
  });

  export const layoutOptionContainer = (selected: boolean) =>
    css(
      {
        textAlign: 'center',
        padding: '12px',
        width: '100%'
      },
      selected
        ? {
            backgroundColor: '#FAFAFA',
            cursor: 'default',
            pointerEvents: 'none'
          }
        : undefined
    );

  export const svgContainer = css({
    margin: space.stack.sm
  });
}
